import React, {PropsWithChildren} from 'react';
import {THEME, VARIANT} from 'app/constants';
import {
  TranscriptionButtonComponent,
  TranscriptionButtonProps,
} from 'app/components/sharedReactComponents/StartStopTranscriptionButton/TranscriptionButtonComponent';

export function StartTranscriptionButton({
  theme = THEME.SECONDARY,
  variant = VARIANT.SOLID,
  children = 'Start transcription',
  ...props
}: PropsWithChildren<TranscriptionButtonProps>) {
  return (
    <TranscriptionButtonComponent theme={theme} variant={variant} {...props}>
      {children}
    </TranscriptionButtonComponent>
  );
}
